import {
  FitnessEventCategory,
  FitnessEventSubCategory,
} from '../gym-management/GymTypes';

export interface EventState {
  events: Event[];
  myActivityEvents: Event[];
  eventsCategories: EventCategory[];
  eventsSubCategories: EventSubCategory[];
  totalPages: number;
  totalResults: number;
  event?: Event;
}

export interface Event {
  id: number;
  name: string;
  category: FitnessEventCategory;
  categoryId: number;
  subCategory: FitnessEventSubCategory;
  subCategoryId: number;
  description: string;
  freeSiteName: string;
  resourceId: number;
  fromDate: number;
  toDate: number;
  capacity: number;
  audience: EventAudienceEnum;
  participants: EventParticipant[];
  status: EventStatusEnum;
  creditAllowed: boolean;
  image: string;
  price: number;
  bookedStatus: BookedStatusEnum;
  resource: EventResource;
  policyId: number;
}

export interface EventCategory {
  id: number;
  name: string;
  code: string;
  subCategories?: EventSubCategory[];
}

export interface EventParticipant {
  id: number;
  eventId: string;
  userId: string;
  status: string;
  user: EventParticipantUser;
}

export interface EventParticipantUser {
  fullName: string;
  image: string;
  email: string;
  phone: string;
}

export interface EventSubCategory {
  id: number;
  name: string;
  categoryId: number;
  code: string;
  image: string;
  isActive: boolean;
}

export interface EventResource {
  id: number;
  building: EventResourceBuilding;
  floor: EventResourceFloor;
}

export interface EventResourceBuilding {
  id: number;
  name: string;
  addressId: number;
  locationId: number;
  location: EventResourceLocation;
}

export interface EventResourceLocation {
  id: number;
  name: string;
  addressId: number;
}

export interface EventResourceFloor {
  id: number;
  number: string;
  buildingId: number;
}

export enum EventStatusEnum {
  FULL = 'FULL',
  CANCELED = 'CANCELED',
  AVAILABLE = 'AVAILABLE',
}

export enum BookedStatusEnum {
  BOOKED = 'BOOKED',
  IN_WAIT_LIST = 'IN_WAIT_LIST',
  AVAILABLE = 'AVAILABLE',
  CANCELED_BY_CMS = 'CANCELED_BY_CMS',
  PENDING_BOOKING = 'PENDING_BOOKING',
}

export enum EventAudienceEnum {
  RESIDENT = 'RESIDENT',
  PORT = 'PORT',
  PORT_AND_RESIDENT = 'PORT_AND_RESIDENT',
}

export enum CategoryEnum {
  EVENT = 'Events',
  FITNESS = 'Fitness',
}

export enum CategoryNameEnum {
  EVENT = 'Events',
  FITNESS = 'Fitness',
}
